/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleLetterJ = createReactComponent("circle-letter-j", "IconCircleLetterJ", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M10 8h4v6a2 2 0 1 1 -4 0", key: "svg-1" }]
]);

export { IconCircleLetterJ as default };
//# sourceMappingURL=IconCircleLetterJ.js.map
